// ── API base (v2 - forzando https siempre) ─────────────────────────
function resolverBase() {
  let url = (process.env.REACT_APP_API_URL || '').trim().replace(/^["']|["']$/g, '');
  if (!url) return '';
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  url = url.replace(/^http:\/\//i, 'https://'); // SIEMPRE forzar https, sin excepción
  return url.replace(/\/+$/, '');
}
const BASE = resolverBase();

export async function api(path, options = {}) {
  const token = localStorage.getItem('iunic_token');
  const res = await fetch(`${BASE}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  });
  if (res.status === 401) {
    localStorage.removeItem('iunic_token');
    localStorage.removeItem('iunic_usuario');
    window.location.reload();
  }
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    let mensaje = err.detail;
    if (Array.isArray(mensaje)) {
      mensaje = mensaje.map(e => e.msg || JSON.stringify(e)).join(' | ');
    } else if (mensaje && typeof mensaje === 'object') {
      mensaje = JSON.stringify(mensaje);
    }
    throw new Error(mensaje || 'Error del servidor');
  }
  return res.json();
}

export function apiUrl(path) {
  return `${BASE}${path}`;
}

// ── Formato moneda ─────────────────────────────────────────────────
export function fmt(n) {
  if (!n && n !== 0) return '—';
  return new Intl.NumberFormat('es-UY', { style: 'currency', currency: 'UYU', maximumFractionDigits: 0 }).format(n);
}

export function fmtDec(n) {
  if (!n && n !== 0) return '—';
  return new Intl.NumberFormat('es-UY', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
}

// ── Fecha ──────────────────────────────────────────────────────────
export function hoy() {
  return new Date().toISOString().split('T')[0];
}

export function fmtFecha(str) {
  if (!str) return '—';
  const [y, m, d] = str.split('-');
  return `${d}/${m}/${y}`;
}

// ── Calcular precio repuesto ───────────────────────────────────────
export function calcPrecio(costo, ivaPct = 22, ganPct = 35, mpPct = 10) {
  const conIva = costo * (1 + ivaPct / 100);
  const conGan = conIva * (1 + ganPct / 100);
  const conMp  = conGan * (1 + mpPct / 100);
  return Math.round(conMp * 100) / 100;
}
